import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    overflowY: 'auto',
    overflowX: 'hidden',
    minWidth: '500px',
    width: '500px',
    maxWidth: '500px',
    height: '100%'
  },

  documentContainer: {
    borderTop: '1px solid #E0E0E0',
    width: '100%',
    maxHeight: '50svh',
    overflowY: 'auto',
    overflowX: 'hidden',
    fontSize: '17px',
    lineHeight: '21px',
    color: '#4A4A4A',
    textAlign: 'left',

    // Should match the agent side editor
    '& p': {
      marginTop: '0px',
      fontWeight: 300,
      fontSize: 14,
      color: '#4A4A4A'
    },

    '& li': {
      fontWeight: 300,
      fontSize: 14
    },

    '& .editor-list-ul': {
      marginLeft: '0'
    },

    '& a': {
      textDecoration: 'underline !important'
    },

    '& strong': {
      display: 'inline-block',
      fontWeight: 'bold',
      marginTop: 20
    },

    '& img': {
      width: '100%',
      margin: '14px 0px'
    },

    '& a, & a:hover': {
      margin: 'inherit',
      padding: 'inherit',
      fontSize: 'inherit',
      color: 'inherit',
      lineHeight: 'inherit'
    },

    '& iframe': {
      width: '100%'
    }
  }
}))

export default useStyles
